import React from 'react';
import ReactDOM from 'react-dom'
import GTip from '../../component/gTip'
import Footer from '../../component/footer'
import GameList from './component/gameList'
import {
    AppContext
} from '../../config/context'
import '../../common/util/polyfill'

class App extends React.Component {
    constructor() {
        super()
        this.state = {
        }
    }

    render() {
        return <AppContext.Provider value={this.state}>
            <GameList></GameList>
            <Footer></Footer>
            <GTip></GTip>
        </AppContext.Provider>
    }
}

ReactDOM.render(<App />, document.getElementById('dokodemodoa'))